import React from 'react'
import { Link, useLocation } from 'react-router-dom';

import './HeaderComponent.css';

const HeaderComponent = () => {
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <>
      <header className="header">
        <nav className="navbar navbar-expand-md fixed-absolute navbar-dark bg-transparent">
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center">
            </div>

            <button className="bg-button navbar-toggler order-2 order-md-1" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>

            <div className="d-none d-md-none d-lg-none d-xl-block collapse navbar-collapse order-3 order-md-2" id="navbar-left">
              <img src="./logo-novo-white.png" width={"70px"} alt="logo" />
            </div>

            <div className="d-none d-md-none d-lg-block d-xl-block navbar-brand order-1 order-md-3">
              <ul className="navbar-nav me-auto">
                <li className="nav-item" style={{ marginLeft: '0px' }}>
                  <Link to="/home" className={`nav-link Bebas-Neue text-items-nav text-white fs-4 fw-bold ${isActive('/home')}`}>Inicio</Link>
                </li>
                <li className="nav-item" style={{ marginLeft: '80px' }}>
                  <Link to="/chapters" className={`nav-link Bebas-Neue text-items-nav text-white fs-4 fw-bold ${isActive('/chapters')}`}>Capítulos</Link>
                </li>
              </ul>
            </div>



            <div className="offcanvas offcanvas-end order-4 order-md-4" tabIndex="-1" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">

              {/* visible in mobile */}
              <div className="offcanvas-header navbar-light background-footer">
                <a className="navbar-brand order-md-1">
                  <img src="./logo-novo-white.png" width={"70px"} alt="logo" />
                </a>
                <button type="button" className="btn-close text-white bg-white" data-bs-dismiss="offcanvas" aria-label="Close"></button>
              </div>

              {/* visible in mobile style */}
              <div className="background-footer offcanvas-body order-4 order-md-4 external-bg-container-include d-block d-md-none d-lg-none d-xl-none">
                <ul className="navbar-nav ms-auto">
                  <li className="nav-item text-center">
                    <span className='text-white fs-4 fw-light text-center'>Bienvenidos</span>
                  </li>

                  <li className="nav-item items-menu-mobile mt-4">
                    <Link to="/home" className={`nav-link Bebas-Neue text-items-nav text-white fs-4 fw-bold text-center ${isActive('/home')}`} >Inicio</Link>
                  </li>
                  <li className="nav-item items-menu-mobile">
                    <Link to="/chapters" className={`nav-link Bebas-Neue text-items-nav text-white fs-4 fw-bold text-center ${isActive('/chapters')}`}>Capítulos</Link>
                  </li>
                </ul>
              </div>

              {/* visible style in pc */}
              <div className="d-none d-md-none d-lg-block d-xl-block offcanvas-body order-4 order-md-4 d-none d-md-flex d-lg-flex d-xl-flex">
                <ul className="navbar-nav ms-auto">
                  <li className="nav-item items-menu-mobile">
                    <span className='text-white fs-4 fw-light'>Bienvenidos</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </nav>
      </header>
      
      <header className="header">
        <nav className="navbar navbar-expand-md fixed-absolute navbar-dark bg-transparent navbar-opacity">
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center">
            </div>

            <button className="bg-button navbar-toggler order-2 order-md-1" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>

            <div className="d-none d-md-none d-lg-none d-xl-block collapse navbar-collapse order-3 order-md-2" id="navbar-left">
              <img src="./logo-novo-white.png" width={"70px"} alt="logo" />
            </div>

            <div className="d-none d-md-block d-lg-block d-xl-block navbar-brand order-1 order-md-3">
              <ul className="navbar-nav me-auto">
                <li className="nav-item" style={{ marginLeft: '0px' }}>
                  <Link to="/home" className={`nav-link Bebas-Neue text-items-nav text-white fs-4 fw-bold ${isActive('/home')}`}>Inicio</Link>
                </li>
                <li className="nav-item" style={{ marginLeft: '80px' }}>
                  <Link to="/chapters" className={`nav-link Bebas-Neue text-items-nav text-white fs-4 fw-bold ${isActive('/chapters')}`}>Capítulos</Link>
                </li>
              </ul>
            </div>



            <div className="offcanvas offcanvas-end order-4 order-md-4" tabIndex="-1" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">

              {/* visible in mobile */}
              <div className="offcanvas-header navbar-light background-footer">
                <a className="navbar-brand order-md-1">
                  <img src="./logo-novo-white.png" width={"70px"} alt="logo" />
                </a>
                <button type="button" className="btn-close text-white bg-white" data-bs-dismiss="offcanvas" aria-label="Close"></button>
              </div>

              {/* visible in mobile style */}
              <div className="background-footer offcanvas-body order-4 order-md-4 external-bg-container-include d-block d-md-none d-lg-none d-xl-none">
                <ul className="navbar-nav ms-auto">
                  <li className="nav-item text-center">
                    <span className='text-white fs-4 fw-light text-center'>Bienvenidos</span>
                  </li>

                  <li className="nav-item items-menu-mobile mt-4">
                    <Link to="/home" className={`nav-link Bebas-Neue text-items-nav text-white fs-4 fw-bold text-center ${isActive('/home')}`} >Inicio</Link>
                  </li>
                  <li className="nav-item items-menu-mobile">
                    <Link to="/chapters" className={`nav-link Bebas-Neue text-items-nav text-white fs-4 fw-bold text-center ${isActive('/chapters')}`}>Capítulos</Link>
                  </li>
                </ul>
              </div>

              {/* visible style in pc */}
              <div className="d-none d-md-none d-lg-block d-xl-block offcanvas-body order-4 order-md-4 d-none d-md-flex d-lg-flex d-xl-flex">
                <ul className="navbar-nav ms-auto">
                  <li className="nav-item items-menu-mobile">
                    <span className='text-white fs-4 fw-light'>Bienvenidos</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </nav>
      </header>
    </>
  )
}

export default HeaderComponent;
